export const adaptAdicionalesResumen = (adicionalData) => {
    return {
        requerimientosAdicionales: adicionalData?.map(x => x?.idComboRIValorReqAdicionalNavigation?.valor)
    }
}